const initialState = {
  data: {},
  loading: false,
  error: null
};

const staticDataReducer = (state = initialState, action) => {
  switch (action.type) {
      case 'LOAD_STATIC_DATA_SUCCESS':
          return {
              ...state,
              data: action.payload,
              loading: false
          };
      case 'LOAD_STATIC_DATA_ERROR':
          return {
              ...state,
              error: action.error,
              loading: false
          };
      default:
          return state;
  }
};

export default staticDataReducer;
